import * as Yup from "yup";

import {
  CreatePromotion,
  CreatePromotionVariables,
} from "_graphql/mutation/__generated__/CreatePromotion";
import { Modal, OfficeButton } from "components";

import { PromotionType } from "_graphql/__generated__/globalTypes";
import { createPromotion } from "_graphql/visal/mutations/promotions";
import moment from "moment";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";

const validationSchema = Yup.object().shape({
  input: Yup.object().shape({
    description: Yup.string().required("Description is required"),
    end_datetime: Yup.date().required("End date is required"),
    name: Yup.string().required("Name is required"),
    start_datetime: Yup.date().required("Start date is required"),
    type: Yup.string().required("Type is required"),
  }),
});

export default function PromoteContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const [execute, { loading: updating }] = useMutation<
    CreatePromotion,
    CreatePromotionVariables
  >(createPromotion, {
    refetchQueries: ["GetPromotions"],
  });

  const form = useFormik<CreatePromotionVariables>({
    initialValues: {
      input: {
        description: "",
        end_datetime: "",
        name: "",
        start_datetime: "",
        type: PromotionType.SHORT_TERM,
      },
    },
    enableReinitialize: false,
    validateOnChange: true,
    validationSchema,
    onSubmit: async (variables, helpers) => {
      execute({
        variables: {
          input: {
            description: variables?.input?.description,
            end_datetime: moment(variables?.input?.end_datetime).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            name: variables?.input?.name || "",
            start_datetime: moment(variables?.input?.start_datetime).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            type: variables?.input?.type,
          },
        },
      })
        .then(({ data }) => {
          if (data?.createPromotion?.id) {
            toast.success("Promotion created successfully");
            setOpen(false);
            helpers.resetForm();
          } else {
            toast.error("Failed to create promotion");
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Promote Campaign"
      description="Draft a message to send to PlaceIt users about this promotion"
      renderActions={() => (
        <OfficeButton
          type="button"
          size="sm"
          loading={updating}
          disabled={updating}
          onClick={wrapClick(form.handleSubmit)}
        >
          {updating ? "Please wait..." : "Promote"}
        </OfficeButton>
      )}
    >
      {/* <PromotionForm form={form} /> */}
    </Modal>
  );
}
